import { computed, ComputedRef, nextTick, Ref, ref } from "vue";
import { Store, useStore } from "vuex";
import { RootState } from "@/store/types.ts";

export const key = Symbol("recordItemControls");

export interface RecordItemControlsApi {
  show: ComputedRef<boolean>;
  deleteRecord: (path: string) => void;
  edit: (path: string) => void;
  editingEntryPath: Ref<string | null>;
}

async function del(store: Store<RootState>, path: string) {
  const { categoryID } = store.state.route.params;
  await store.dispatch("api/deleteEntry", {
    categoryID,
    path,
  });
}

const editingEntryPath: Ref<string | null> = ref(null);

export default function createData(): RecordItemControlsApi {
  const store = useStore();
  return {
    show: computed(() => store.getters.showCMS),
    deleteRecord: (path) => del(store, path),
    edit: async (path) => {
      editingEntryPath.value = null;
      await nextTick(() => {
        editingEntryPath.value = path;
      });
    },
    editingEntryPath,
  };
}

const injectError = `Inject has failed for RecordItemControlsApi`;

export const defaultApi: RecordItemControlsApi = {
  show: computed(() => false),
  deleteRecord: () => console.error(injectError),
  edit: () => console.error(injectError),
  editingEntryPath: ref(null),
};

export const storybookApi: RecordItemControlsApi = {
  show: computed(() => false),
  deleteRecord: (path) => alert(`Delete record with path: ${path}`),
  edit: (path) => alert(`Edit record item with path: ${path}`),
  editingEntryPath: ref(null),
};
